import Vue from 'vue'
import store from '~/store'
import VueI18n from 'vue-i18n'

Vue.use(VueI18n)

const i18n = new VueI18n({
  locale: 'en',
  messages: {}
})

/**
 * @param {String} locale
 */
export async function loadMessages (locale) {
  if (Object.keys(i18n.getLocaleMessage(locale)).length === 0) {
    try {
      const messages = await import(/* webpackChunkName: '' */ `~/lang/${locale}`)
      i18n.setLocaleMessage(locale, messages)
    } catch (error) {
      console.error('Failed to load locale messages', error)
      if (
        error.name === 'ChunkLoadError' ||
        /^Loading( CSS)? chunk (\d)+ failed\./.test(error.message) ||
        (error.message && error.message.includes('Loading chunk'))
      ) {
        const lastReload = sessionStorage.getItem('last_chunk_load_reload')
        const now = Date.now()
        if (lastReload && now - parseInt(lastReload, 10) < 10000) {
          console.error('Chunk loading failed repeatedly. Stopping reload to avoid infinite loop.')
          throw error
        }
        sessionStorage.setItem('last_chunk_load_reload', now.toString())
        window.location.reload(true)
        return
      }
      throw error
    }
  }

  if (i18n.locale !== locale) {
    i18n.locale = locale
  }
}

;(async function () {
  await loadMessages(store.getters['lang/locale'])
})()

export default i18n
